import { toast } from "src/hooks/useToast";
export const validateInvoiceProducts = (products: any[]): boolean => {
    let isValid = true;
    products.forEach((item) => {
        const { item_description, item_code, inv_mrp, ptr, batch_no, free_qty, quantity, pts, is_item_unknown } = item;
        if (
            batch_no === undefined ||
            batch_no === null ||
            batch_no === "" ||
            batch_no === "undefined"
        ) {
            toast({
                description: `Item "${item_description}" has an invalid batch_no.`,
                variant: "destructive",
            });
            isValid = false;
        }
        if (
            item_code === undefined ||
            item_code === null ||
            item_code === "" ||
            item_code === "undefined"
        ) {
            toast({
                description: `Item "${item_description}" has an invalid item_code.`,
                variant: "destructive",
            });
            isValid = false;
        }
        if (
            inv_mrp === undefined ||
            inv_mrp === null ||
            inv_mrp === "" ||
            inv_mrp === "undefined" ||
            Number(inv_mrp) === 0 ||
            Number(inv_mrp) < 0
        ) {
            toast({
                description: `Item "${item_description}" has an invalid inv_mrp.`,
                variant: "destructive",
            });
            isValid = false;
        }
        if (
            ptr === undefined ||
            ptr === null ||
            Number(ptr) === 0 ||
            Number(ptr) < 0
        ) {
            toast({
                description: `Item "${item_description}" has an invalid ptr.`,
                variant: "destructive",
            });
            isValid = false;
        }
        if (
            !is_item_unknown && (
                pts === undefined ||
                pts === null ||
                Number(pts) === 0 ||
                Number(pts) < 0
            )
        ) {
            toast({
                description: `Item "${item_description}" has an invalid pts.`,
                variant: "destructive",
            });
            isValid = false;
        }
        if (
            Number(free_qty) < 0
        ) {
            toast({
                description: `Item "${item_description}" has an invalid Free Qty.`,
                variant: "destructive",
            });
            isValid = false;
        }
        if (
            Number(quantity) < 0
        ) {
            toast({
                description: `Item "${item_description}" has an invalid Quantity.`,
                variant: "destructive",
            });
            isValid = false;
        }

    });
    return isValid;
};